"use strict";

exports.__esModule = true;
var _DeviceDataItemQueryController = require("./DeviceDataItemQueryController");
Object.keys(_DeviceDataItemQueryController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceDataItemQueryController[key]) return;
  exports[key] = _DeviceDataItemQueryController[key];
});